// Shared DEVELOPMENTAL BAND derivation for the Composition + Sentence Craft progress meters.
// Deterministic, no scoring shown to the learner: maps genuine resolved-target movement toward a stage's
// readiness onto a small number of MEANINGFUL developmental positions. The internal FILL values drive the
// bar width only — they are never displayed as a percentage. CommonJS so both the React app (webpack) and
// the Node test can consume it.

const BANDS = ["initial", "early", "substantial", "nearly", "ready"];
const FILL = { initial: 15, early: 35, substantial: 60, nearly: 80, ready: 100 };
const BAND_LABEL = {
  initial: "Getting started",
  early: "Early progress",
  substantial: "Substantial progress",
  nearly: "Nearly ready",
  ready: "Ready",
};

// resolved = genuine resolved targets THIS session; budget = the stage's bounded target count; ready =
// the engine's readiness/closure flag. Readiness always wins (READY ≠ perfection; optional work is beyond
// the endpoint). Before any real resolution we show an INITIAL position, never an empty "you've done
// nothing" bar. The caller clamps this monotonically so ordinary new-target discovery never regresses it.
function computeBand({ resolved = 0, budget = 0, ready = false } = {}) {
  if (ready) return "ready";
  if (resolved <= 0) return "initial";
  if (budget <= 0) return "early";
  const r = resolved / budget;
  if (r >= 1) return "nearly";      // budget numerically met but engine hasn't flagged readiness yet
  if (r >= 0.6) return "substantial";
  return "early";
}

function bandIndex(band) {
  const i = BANDS.indexOf(band);
  return i < 0 ? 0 : i;
}

module.exports = { BANDS, FILL, BAND_LABEL, computeBand, bandIndex };
